<template>
    <div class="story-maker-sticker story-maker-sticker-product" :class="{edit : isEditing}">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">Terminé</p>
        <div class="sticker sticker-product" 
            :class="`style${styleVariant}`"
            :style="{ 
                    top: `${$attrs.position.y}%`, 
                    left: `${$attrs.position.x}%`,
                    transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
                }"
            >
           <div class="icon" :style="{backgroundColor:models.color}"></div>
            <p 
                :class="`${models.font}`"
                :style="{color:models.color}"
            >
                {{ products.length == 1 ? products[0].text : `${products.length} produits` }}
            </p>
        </div>
        <div class="options">

            <div class="list-option-text hide-scrollbar">
                <div class="texts">
                    <div class="text modern modern-font" :class="{active : models.font == 'modern-font'}" @click="models.font = 'modern-font'">Modern</div>
                    <div class="text classic classic-font" :class="{active : models.font == 'classic-font'}" @click="models.font = 'classic-font'">Classic</div>
                    <div class="text signature signature-font" :class="{active : models.font == 'signature-font'}" @click="models.font = 'signature-font'">Signature</div>
                    <div class="text editor editor-font" :class="{active : models.font == 'editor-font'}" @click="models.font = 'editor-font'">Editor</div>
                    <div class="text poster poster-font" :class="{active : models.font == 'poster-font'}" @click="models.font = 'poster-font'">Poster</div>
                    <div class="text bubble bubble-font" :class="{active : models.font == 'bubble-font'}" @click="models.font = 'bubble-font'">Bubble</div>
                    <div class="text deco deco-font" :class="{active : models.font == 'deco-font'}" @click="models.font = 'deco-font'">Deco</div>
                    <div class="text squeeze squeeze-font" :class="{active : models.font == 'squeeze-font'}" @click="models.font = 'squeeze-font'">Squeeze</div>
                    <div class="text typewriter typewriter-font" :class="{active : models.font == 'typewriter-font'}" @click="models.font = 'typewriter-font'">Typewriter</div>
                    <div class="text strong strong-font" :class="{active : models.font == 'strong-font'}" @click="models.font = 'strong-font'">Strong</div>
                    <div class="text meme meme-font" :class="{active : models.font == 'meme-font'}" @click="models.font = 'meme-font'">Meme</div>
                    <div class="text elegant elegant-font" :class="{active : models.font == 'elegant-font'}" @click="models.font = 'elegant-font'">Elegant</div>
                    <div class="text directional directional-font" :class="{active : models.font == 'directional-font'}" @click="models.font = 'directional-font'">Directional</div>
                    <div class="text literature literature-font" :class="{active : models.font == 'literature-font'}" @click="models.font = 'literature-font'">Literature</div>
                </div>
            </div>

            <div class="list-option-color">
                <div class="pipette">
                    <div class="icon" :style="{backgroundColor: pickerColors.hex}" @click="()=>{ models.color = pickerColors.hex; colorPickerShow = true; showPipette = true}">

                    <div class="picker-color" v-if="colorPickerShow" @mouseleave="colorPickerShow = false" @mousedown="showPipette = false">
                        <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                        <chrome-picker :value="pickerColors" @input="updateFromPicker"/>
                    </div>
                    
                </div></div>
                <div class="color-carousel">
                    <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                        <Slide v-for="(colors,index) in [['#FFFFFF','#000000','#4397EF','#70C04F','#F6CB5B','#F08C34','#EA4857','#D12D69','#B100C0'],['#EA3323','#ED858E','#F7D0D1','#FADAB4','#F5C281','#D18E47','#99643A','#432324','#1D4A29'],['#262626','#363636','#555555','#737373','#999999','#B2B2B2','#C7C7C7','#DBDBDB','#EFEFEF']]" :key="index">
                            <div v-for="colorHexa in colors" class="color" :style="`background-color:${colorHexa}`" @click="()=>{models.color = colorHexa; pickerColors.hex = colorHexa}"></div>
                        </Slide>
                    </carousel>
                        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import { Chrome } from 'vue-color'
    export default {
        components: {
            Carousel,
            Slide,
            'chrome-picker': Chrome,
        },
        props: {
            id: [Number, String],
            isEditing: Boolean,
            products: Array,
            font: String,
            color: String,
            styleVariant: Number,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },

        data() {
            return {
                models: {
                    font: 'classic-font',
                    color: '#000'
                },
                timeoutFinish: null,

                colorPickerShow: false,

                pickerColors: {
                    hex: '#000000',
                },
                
                eyeDropperIsAccess : false,
                showPipette : true,
            }
        },

        mounted () {
            this.eyeDropperIsAccess = window.EyeDropper ? true : false;
            if (this.setCbClick) this.setCbClick(this.changeStyleVariant);
        },
        methods: {
            clickSticker() {
                if (this.isEditing) return 
                this.setCover(true)
                this.$nextTick(()=> {
                    this.$emit('updateSticker',this.id , {
                        isEditing: true
                    })   
                })
            },
            
            finish() {
                
                this.$emit('updateSticker',this.id , {
                    isEditing: false,
                })

                if (this.timeoutFinish) clearTimeout(this.timeoutFinish)
                this.timeoutFinish = setTimeout(() => {
                    this.setCover(false)
                }, 200);
 
            },

            changeStyleVariant(e) {
                this.$emit('updateSticker',this.id , {
                    data : {
                        ...this.$attrs.data,
                        styleVariant :(this.styleVariant % 4) + 1
                    },
                })
            },

            updateFromPicker(value) {
                this.pickerColors = {
                    hex: value.hex
                }
                this.models.color = value.hex
            },

            startEyeDropper() {
                if (!window.EyeDropper) return
                this.colorPickerShow = false
                const eyeDropper = new EyeDropper();

                eyeDropper.open().then((result) => {
                    this.models.color = result.sRGBHex
                    this.pickerColors = {
                        hex: result.sRGBHex
                    }
                }).catch((e) => {
                });
            }
        },

        watch: {
            font: {
                handler(newValue) {
                    this.models.font = newValue
                },
                immediate: true
            },
            color: {
                handler(newValue) {
                    this.models.color = newValue
                },
                immediate: true
            },
            isEditing: {
                handler(newValue) {
                    if (newValue && !this.isPreventCover && !this.isCover) {
                        this.isEditing = false
                        this.clickSticker()
                    }
                },
                immediate: true
            },
        },
    }
</script>
